// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_service th {
  padding: 14px;
  text-align: left;
  cursor: default;
}

#service_item {
  padding: 14px;
  text-align: left;
  cursor: default;
}

.category_item {
  width: 290px;
}

.price_item {
  width: 126px;
}

.button_item {
  width: 104px;
}`, "",{"version":3,"sources":["webpack://./src/components/ServicesListing/ServicesListing.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,gBAAA;EACA,eAAA;AAFJ;;AAIA;EACI,aAAA;EACA,gBAAA;EACA,eAAA;AADJ;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;;AAEA;EACI,YAAA;AACJ","sourcesContent":[".listing_table-service_title {\r\n    // width: 400px;\r\n}\r\n.table_service th {\r\n    padding: 14px;\r\n    text-align: left;\r\n    cursor: default;\r\n}\r\n#service_item {\r\n    padding: 14px;\r\n    text-align: left;\r\n    cursor: default;\r\n}\r\n.category_item {\r\n    width: 290px;\r\n}\r\n\r\n.price_item {\r\n    width: 126px;\r\n}\r\n.button_item {\r\n    width: 104px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
